import '../App.css';
import '../scss/App.scss';


import { Box, Container, Grid, Link } from '@mui/material';
import Templecard from '../layout/tamplecard/Templecard';
import Servicecard from '../layout/services/Servicecard';
import Slider from '../layout/slickslider/slider';
import TravelSection from '../layout/travel/TravelSection';
import Cityslider from '../layout/slickslider/Cityslider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Stories from '../layout/stories/Storeis';
import Banner from '../layout/header/Banner';
import Content from '../layout/content-box/Content';
import SEO from '../seo/SEO';


const { templeData, serviceData } = Content[0];
function App() {


 


    const templeData = [
      { image: '/assets/tample/tample11.svg', name: 'Dwarkadhish', link:"dwarkadhish-temple" },
      { image: '/assets/tample/ayodhya-temple.svg', name: 'Ayodhya', link:"ayodhya" },
      { image: '/assets/tample/tample9.svg', name: 'Kashi Vishwanath', link:"kashi-vishwanath" },
      { image: '/assets/tample/tample12.svg', name: 'Rameswaram', link:"ramanathaswamy-temple" },
  { image: '/assets/tample/tample3.svg', name: 'Vaishno Devi', link:"vaishno-devi" },
  
];



  return (
    <>
      <SEO pageKey="oldHome" />
      <Banner />
      <Box className="templeBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Box className="templeInnerHeading">
                <h2>{Content[0].templeHeading}</h2>
                <p>{Content[0].templeSubHeading}</p>
              </Box>
            </Grid>
            {templeData.map((temple, index) => (
              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Link href={temple.link}><Templecard key={index} image={temple.image} name={temple.name} /></Link>
              </Grid>
            ))}
          <Grid size={12}>
            <Box className="text-center mt-3">
          <Link href="/listing" className="primaryBtn">View All</Link>
          </Box>
          </Grid>
          </Grid>
        </Container>
      </Box>

      
      <Box className="serviceCardBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Box className="templeInnerHeading">
                <h2>{Content[0].serviceHeading}</h2>
                <p>{Content[0].serviceSubHeading}</p>
              </Box>
            </Grid>
            {serviceData.map((service, index) => (
              <Grid size={{ xl: 2, lg: 2, md: 2, sm: 6, xs: 6 }}>
                <Link href={service.link} target={service.target} rel="noopener noreferrer" className='text-decoration-none text-dark'><Servicecard key={index} image={service.image} name={service.name} /></Link>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      <Cityslider />
      <TravelSection />
      <Slider />      
      <Stories />
    
      

     

    </>
  );
}
export default App;